/**
 * Build-time configuration for the Office Add-in.
 *
 * webpack DefinePlugin injects ORPC_BASE_URL as a bare identifier (string
 * literal). Do not read process.env at runtime and do not guard with
 * `typeof process` — `process` is not a browser global, so those guards
 * discard the injected value and fall back to the wrong host
 * (historically https://docuid.net, which is marketing, not the API).
 */

declare const ORPC_BASE_URL: string;
declare const MARKETING_URL: string;

/**
 * Origin of the DocuID dashboard that serves /api/rpc, /api/files, /api/uploads.
 * Example: https://localhost:3001 or https://dashboard.docuid.net
 */
export function getDashboardBaseUrl(): string {
  return ORPC_BASE_URL;
}

/**
 * Origin of the public marketing site. Injected at build time from MARKETING_URL
 * in .env, or derived from ORPC_BASE_URL for the current environment.
 */
export function getMarketingUrl(): string {
  return MARKETING_URL.replace(/\/$/, '');
}
